import PsychologyIcon from '@mui/icons-material/Psychology';
import CodeIcon from '@mui/icons-material/Code';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import AccountTreeIcon from '@mui/icons-material/AccountTree';

export function getSections(test) {
  if (Array.isArray(test?.sections) && test.sections.length > 0) {
    return test.sections.map((section) => ({
      key: section.key,
      label: section.label,
      scoreKey: section.scoreKey || `${section.key}Score`,
      questions: section.questions || [],
    }));
  }

  return [
    {
      key: 'aptitude',
      label: 'Aptitude',
      scoreKey: 'aptitudeScore',
      questions: test?.aptitudeQuestions || [],
    },
    {
      key: 'programming',
      label: 'Programming',
      scoreKey: 'programmingScore',
      questions: test?.programmingQuestions || [],
    },
  ];
}

export function getSectionIndex(test, sections) {
  if (
    Number.isInteger(test?.currentSectionIndex) &&
    test.currentSectionIndex >= 0 &&
    test.currentSectionIndex < sections.length
  ) {
    return test.currentSectionIndex;
  }

  if (test?.currentQuestionType) {
    const index = sections.findIndex((section) => section.key === test.currentQuestionType);
    if (index >= 0) {
      return index;
    }
  }

  return 0;
}

export function getSecondsPerQuestion(test) {
  const seconds = Number(test?.secondsPerQuestion);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : 60;
}

export function initialSectionScores(sections) {
  return sections.reduce((scores, section) => {
    scores[section.scoreKey] = 0;
    return scores;
  }, {});
}

export function sectionIcon(sectionKey) {
  if (sectionKey === 'programming') {
    return <CodeIcon />;
  }
  if (sectionKey === 'inconsistencies') {
    return <FactCheckIcon />;
  }
  if (sectionKey === 'stages') {
    return <AccountTreeIcon />;
  }
  return <PsychologyIcon />;
}
